/**
 * organizes service
 */

import Resource from './resource'

export default new Resource('organizes')



// WEBPACK FOOTER //
// ./src/libraries/services/organizes.js